
async function addQuickPicker(id) {
    const pickerComponent = document.querySelector(`[data-quick-picker-id="${id}"]`)
    // console.log(pickerComponent)
    const productVariant = pickerComponent.querySelector('[data-variant-selected]').dataset
    const productVariantId = productVariant.variantId
    const buttonVariant = pickerComponent.querySelector('button')
    
    console.log('productVariantId', productVariantId)

    buttonVariant.disabled = true

    let formData = {
        'items': [{
            'id': productVariantId,
            'quantity': 1
        }]
    };
       
    const addVariantCart = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        return response.json();
    })
    .catch((error) => {
        console.error('Error:', error);
    });

    
    if (addVariantCart.items) {
        console.log('OK addtocart')
        console.log(addVariantCart)
        buttonVariant.disabled = false
        populateDropsCartModal(addVariantCart.items[0])
    } else {
        console.log('ERROR addtocart')
        buttonVariant.disabled = false
        console.log(addVariantCart)
    }
       
}

function renderPickerAppChanges(data) {
    console.log('data', data)
    const priceComponent = data.target.querySelector('[drops-price-quick-price]')
    const priceRegular = data.target.querySelector('[drop-picker-prices-regular]')
    const priceCompare = data.target.querySelector('[drop-picker-prices-compare]')

    priceComponent.classList.add('drops-quick-picker--hide')
    priceRegular.innerHTML = `${data.price}`
    if (data.compare_at_price <= 0) {
        priceRegular.classList.add('picker-prices--regular')
        priceCompare.innerHTML = ``
    } else {
        priceRegular.classList.remove('picker-prices--regular')
        priceCompare.innerHTML = `${data.compare_at_price}`
    }
}

function quickPickerApp() {
    const pickerComponent = Array.from(document.querySelectorAll('[data-quick-picker-id]'))
    let variantSelectors = []

    pickerComponent.forEach(selectors => {
        variantSelectors.push(Array.from(selectors.querySelectorAll('span')))
    })
    

    variantSelectors.forEach(selectorGroup => {
        
        selectorGroup.forEach(variantPicker => {
            // console.log(variantPicker.dataset.variantId)

            variantPicker.addEventListener('click', function(event) {
                
                if (event.target.dataset.variantNotAvailable != undefined) {
                    console.log('variant not available')
                    return false
                }
                
                selectorGroup.forEach(variantPicker => {
                    // variantPicker.classList.remove('variant-selected')
                    variantPicker.removeAttribute('data-variant-selected')
                })

                // event.target.classList.add('variant-selected')
                event.target.setAttribute('data-variant-selected', '')

                const data = {
                    target: event.target.closest('.drops-quick-picker'),
                    price: event.target.dataset.variantPrice,
                    compare_at_price: event.target.dataset.variantCompare
                }

                renderPickerAppChanges(data)

            })
            
        });

    });
    
    // console.log(variantSelector)
}

// Init
quickPickerApp()